module.exports = __webpack_public_path__ + "static/media/IMG_0106.a5b5ef81.jpg";